import React from 'react';

export default React.createContext({ isDev: false, features: {} });